<template>
  <div class="general-ledger">
    <table
      class="TB_COLLAPSE"
      width="1200"
    >
      <tbody>
        <tr style="border-top: 1px solid #7893c7">
          <th
            class="tableTh"
            style="width: 70px"
          >站点</th>
          <td
            class="text-left"
            style="padding-top: 0"
          >
            <div class="station-block pl-2 pt-1">
              <Checkbox
                v-model="station.allSation"
                @on-change="(val) => checkTitle(val, 3)"
              >全部站点</Checkbox>
              <CheckboxGroup
                v-model="station.stationArr"
                style="display: inline-block"
              >
                <Checkbox
                  :label="it.stid"
                  v-for="it in station.stations"
                  :key="it.id"
                >
                  <span>{{ it.stname }}</span>
                </Checkbox>
              </CheckboxGroup>
            </div>
          </td>
        </tr>
        <tr>
          <th class="tableTh">游戏</th>
          <td class="text-left">
            <p>
              <Checkbox
                v-model="allGame"
                class="pl-2 pb-1"
                @on-change="(val) => checkTitle(val, 1)"
              >全部游戏</Checkbox>
            </p>
            <div>
              <p class="tableTh pa-1">
                <Checkbox
                  v-model="allLottery"
                  class="pl-1"
                  @on-change="(val) => checkTitle(val, 2)"
                >彩票</Checkbox>
              </p>
              <table
                width="100%"
                class="inner-table"
              >
                <tr>
                  <th
                    v-for="(it, key, idx) in lottery"
                    style="box-sizing: border-box"
                  >
                    <p class="pa-1 title">
                      <Checkbox
                        v-model="it.all"
                        class="pl-1"
                        @on-change="(val) => checkTitle(val, it.idArr)"
                      >{{ it.title }}</Checkbox>
                    </p>
                  </th>
                </tr>
                <tr>
                  <td
                    v-for="(it, key, idx) in lottery"
                    style="vertical-align: top"
                  >
                    <CheckboxGroup v-model="totalIdArr">
                      <div
                        v-for="(dit, dataind) in it.data"
                        :class="[
                          it.data[dataind].length ? 'check-part' : '',
                          'text-left',
                        ]"
                      >
                        <Checkbox
                          class="pa-1 pl-2"
                          v-for="item in dit"
                          :label="item.gameid"
                          :key="item.gameid"
                        >
                          <span>{{ item.gamename }}</span>
                        </Checkbox>
                      </div>
                    </CheckboxGroup>
                  </td>
                </tr>
              </table>
            </div>
            <div
              v-for="it, key in exgameLotteryList"
              :key="key"
            >
              <p class="tableTh pa-1">
                <Checkbox
                  v-model="it.all"
                  class="pl-1"
                  @on-change="(val) => checkTitle(val, it.idArr)"
                >{{it.title}}</Checkbox>
              </p>
              <p class="text-left pl-2 pt-1">
                <CheckboxGroup v-model="totalIdArr">
                  <Checkbox
                    :label="item.id"
                    v-for="item in it.data"
                    :key="item.id"
                  >
                    <span>{{ item.gamename }}</span>
                  </Checkbox>
                </CheckboxGroup>
              </p>
            </div>
          </td>
        </tr>
        <tr>
          <th class="tableTh">日期</th>
          <td class="text-left">
            <div class="pl-2">
              <DatePicker
                type="date"
                placeholder="选择开始日期"
                v-model="stdate"
                format="yyyy-MM-dd"
                style="width: 150px"
                :clearable="false"
                :options="datePickerOptions" 
              ></DatePicker>
              <span class="mx-1">~</span>
              <DatePicker
                type="date"
                placeholder="选择结束日期"
                v-model="endate"
                format="yyyy-MM-dd"
                style="width: 150px"
                :clearable="false"
                :options="datePickerOptions" 
              ></DatePicker>
              <Button
                class="ml-2 dateBtn"
                type="primary"
                v-for="item in btnList"
                @click="reportdate(item.id)"
                :key="item.id"
              >{{ item.name }}</Button>
            </div>
            <div class="red-text mt-1 pl-2">注意:只能查询最近{{searchDays}}天的报表！</div>
          </td>
        </tr>
        <tr>
          <th class="tableTh pa-1">结算状态</th>
          <td class="text-left">
            <RadioGroup
              v-model="wilo"
              class="pl-2"
            >
              <Radio :label="1">已结算</Radio>
              <Radio :label="2">未结算</Radio>
            </RadioGroup>
          </td>
        </tr>
        <tr v-if="!station.allSation">
          <th class="tableTh pa-1">会员账号</th>
          <td class="text-left px-2">
            <Input
              class="input-placeholder-center"
              placeholder="(非必填)"
              style="width: 150px"
              v-model="account"
            ></Input>
          </td>
        </tr>
        <tr style="border: none">
          <Button
            class="left ml-2 mt-2"
            type="error"
            @click="search()"
          >查詢</Button>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { Handle } from 'utils';
import { mapGetters } from 'vuex'
import moment from "moment";
export default {
  name: 'search',
  data () {
    return {
      btnList: [
        { id: 1, name: '今日' },
        { id: 2, name: '昨天' },
        { id: 3, name: '本周' },
        { id: 4, name: '上周' },
        { id: 5, name: '本月' },
        { id: 6, name: '上月' }
      ],
      gameSelect: [
        { label: '全部', value: '0' }
      ],
      dateSelect: [],
      stdate: moment().format(),
      endate: moment().format(),
      setGame: '0',
      wilo: 1,
      allGame: true,
      allLottery: true,
      exgameLotteryList: {},
      station: {
        stations: [
          { name: '12', id: 1 }, { name: 'a6', id: 2 },
          { name: 'a63', id: 3 }, { name: 'n7', id: 4 },
          { name: 'v7', id: 5 }, { name: 'a7', id: 6 },
          { name: 'xb', id: 7 }
        ],
        stationArr: [],
        allSation: true
      },
      totalIdArr: [],
      account: '', // 会员帐ㄒ
      searchDays: 600
    };
  },
  computed: {
    ...mapGetters(['getgameid', 'getAllGame', 'getmember', 'getExgameList']),
    datePickerOptions () {
      const days = this.searchDays * -1 + 1
      const daysStr = moment(moment().add(days, 'days')).format('YYYY-MM-DD')
      return {
        disabledDate (date) {
          const dateStr = moment(date).format('YYYY-MM-DD')
          return (moment(dateStr).isBefore(daysStr) || moment(date).isAfter(moment()))
        }
      }
    },
    lottery () {
      if (!this.getAllGame.length) return
      let fn = (val) => {
        return this.getAllGame.filter(it => it.catenaId == val)
      }
      let obj = {
        six: {
          title: '六合彩系列', all: false,
          data: this.getLotteryType(fn(1)),
          idArr: fn(1).map(it => it.gameid)
        },
        pk10: {
          title: 'PK拾系列', all: false,
          data: this.getLotteryType(fn(2)),
          idArr: fn(2).map(it => it.gameid)
        },
        midP: {
          title: '潮汕盘口系列', all: false,
          data: this.getLotteryType(fn(12)),
          idArr: fn(12).map(it => it.gameid)
        },
        time: {
          title: '时时彩系列', all: false,
          data: this.getLotteryType(fn(3)),
          idArr: fn(3).map(it => it.gameid)
        },
        fast10: {
          title: '快十系列', all: false,
          data: this.getLotteryType(fn(4)),
          idArr: fn(4).map(it => it.gameid)
        },
        fast3: {
          title: '快三系列', all: false,
          data: this.getLotteryType(fn(5)),
          idArr: fn(5).map(it => it.gameid)
        },
        select5: {
          title: '11选5系列', all: false,
          data: this.getLotteryType(fn(6)),
          idArr: fn(6).map(it => it.gameid)
        },
        keno: {
          title: '基诺彩系列', all: false,
          data: this.getLotteryType(fn(7)),
          idArr: fn(7).map(it => it.gameid)
        },
        tcpl3: {
          title: '福利彩系列', all: false,
          data: this.getLotteryType(fn(8)),
          idArr: fn(8).map(it => it.gameid)
        },
        pc28: {
          title: '28系列', all: false,
          data: this.getLotteryType(fn(9)),
          idArr: fn(9).map(it => it.gameid)
        },
        sports: {
          title: '体育彩系列', all: false,
          data: this.getLotteryType(fn(10)),
          idArr: fn(10).map(it => it.gameid)
        },
        official: {
          title: '官方彩系列', all: false,
          data: this.getLotteryType(fn(11)),
          idArr: fn(11).map(it => it.gameid)
        },
      }
      return obj
    },
  },
  watch: {
    totalIdArr (val) {
      if (val.length == this.getAllGame.length + 8) {
        this.allGame = true;
      } else {
        this.allGame = false;
      }
      let allArr = []
      for (let key in this.lottery) {
        const item = this.lottery[key]
        const status = item.idArr.length ? item.idArr.every(it => val.includes(it)) : false
        this.$set(item, 'all', status)
        allArr.push(this.lottery[key].all)
      }
      this.allLottery = allArr.every(it => it)
      Object.keys(this.exgameLotteryList).map(key => {
        const item = this.exgameLotteryList[key]
        const status = item.idArr.every(it => val.includes(it))
        item.all = status
      })
    },
    "station.stationArr" (val) {
      this.station.allSation = val.length == this.station.stations.length
      if (this.station.allSation) this.account = ''
    }
  },
  mounted () {
    this.getpmtge()
    this.getsiteList()
    this.checkTitle(true, 1)
  },
  methods: {
    async getpmtge () {
      try {
        // 要添加的遊戲 cq9 yeebet 
        const showGameId = [101, 102, 103, 104, 105, 126, 128, 129, 130]
        this.exgameLotteryList = this.getExgameList.filter(it => showGameId.includes(it.id)).reduce((acc, val, i) => {
          if (`exgame-${val.catenaId}` in acc == false) {
            acc[`exgame-${val.catenaId}`] = {
              title: val.gamehall,
              data: [],
              idArr: [],
              all: false
            }
          }
          acc[`exgame-${val.catenaId}`].data.push(val)
          acc[`exgame-${val.catenaId}`].idArr.push(val.id)
          return acc
        }, {})
      } catch (error) {
        console.log(error);
      }
    },
    reportdate (id) {
      switch (id) {
        case 1:
          let today = moment().format('YYYY-MM-DD');
          this.stdate = today;
          this.endate = today;
          break;
        case 2:
          let yesterday = moment(new Date()).add(-1, 'days').format('YYYY-MM-DD');
          this.stdate = yesterday;
          this.endate = yesterday;
          break;
        case 3:
          let day1 = moment().startOf('isoweek').format('YYYY-MM-DD')
          let day7 = moment().endOf('isoweek').format('YYYY-MM-DD')
          this.stdate = day1;
          this.endate = day7;
          break;
        case 4:
          let upday1 = moment().startOf('isoweek').subtract('isoweek', 1).format('YYYY-MM-DD'); // 周一日期
          let upday7 = moment().endOf('isoweek').subtract('isoweek', 1).format('YYYY-MM-DD'); // 周日日期
          this.stdate = upday1;
          this.endate = upday7;
          break;
        case 5:
          let month1 = moment().startOf('month').format('YYYY-MM-DD')
          let month2 = moment().endOf('month').format('YYYY-MM-DD')
          this.stdate = month1;
          this.endate = month2;
          break;
        case 6:
          let upmonth1 = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD')
          let upmonth2 = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD')
          this.stdate = upmonth1;
          this.endate = upmonth2;
          break;
      }
    },
    async search () {
      if (this.station.stationArr == 0) return this.$Message.error("请选择站别")
      if (this.totalIdArr.length == 0) return this.$Message.error("请选择游戏")
      let query = {
        stidlist: this.station.stationArr.join(","),
        gmclist: this.totalIdArr.join(","),
        stdate: moment(this.stdate).format("YYYY-MM-DD"),
        endate: moment(this.endate).format("YYYY-MM-DD"),
        iscal: this.wilo,
        mid: 1,
        gamelist: this.totalIdArr.join(","),
      }

      if (this.$route.meta.name == "generalLedger") {
        let routerName
        if (this.account) {
          try {
            const res = await this.$axios.generalLedger.GetMemberNumberForSite({ stid: this.station.stationArr[0], loid: this.getmember.pid, username: this.account })
            if ('status' in res && res.status === 0) return
            if (res[0].data.status === 1) {
              query.mid = res[0].data.mid
              routerName = 'general-ledger-reporta8'
            } else {
              this.$Message.error("查无此帐户");
            }
          } catch (error) {
            console.error(error)
          }
        } else {
          routerName = 'general-ledger-reporta1'
        }
        routerName ? this.$router.push({ name: routerName, query }) : null
      }
      if (this.$route.meta.name == "assortLedger") {
        this.account ? query.username = this.account : null
        this.$router.push({
          name: 'assort-ledger-report1',
          query
        })
      }
    },
    async getsiteList () {
      try {
        const res = await this.$axios.generalLedger.getsitelist()
        if ('status' in res && res.status === 0) return
        this.station.stations = res
        res.forEach(item => {
          this.station.stationArr.push(item.stid)
        })
      } catch (error) {
        console.error(error)
      }
    },
    getLotteryType (arr) {
      let arr1 = []
      let arr2 = []
      let arr3 = []
      arr.forEach(it => {
        if (it.siteId == 0) arr1.push(it)
        if (it.siteId == 1) arr2.push(it)
        if (it.siteId == 2) arr3.push(it)
      })
      let allarr = [arr1, arr2, arr3]
      return allarr
    },
    getExgameIdArr () {
      const result = Object.keys(this.exgameLotteryList)
        .reduce((acc, val) => {
          const item = this.exgameLotteryList[val]
          acc.push(...item.idArr)
          return acc
        }, [])
      return result
    },
    checkTitle (val, arr) {
      let fn = (array, status) => {
        if (status) {
          this.totalIdArr.push(...array)
          this.totalIdArr = Array.from(new Set(this.totalIdArr));
        }
        if (!status) this.totalIdArr = this.totalIdArr.filter(it => !array.some(idx => it == idx))
      }
      if (Array.isArray(arr)) {
        fn(arr, val)
      } else {
        let totalLotId = []
        for (let key in this.lottery) {
          totalLotId.push(...this.lottery[key].idArr)
        }
        if (arr == 1) return fn([...totalLotId, ...this.getExgameIdArr()], val)
        if (arr == 2) return fn(totalLotId, val)
        if (arr == 3) return this.station.stationArr = val ? this.station.stations.map(it => it.stid) : []
      }
    },
  },
};
</script>
<style lang="scss">
.general-ledger {
  .dateBtn {
    color: #fff;
    background-color: #909090;
    border-color: #909090;
  }
  .allcheck {
    color: #fff;
    padding: 5px 2px;
  }
  .tableTh {
    background: #1d3c78;
    color: #fff;
    border: solid 1px #797979;
  }
  table.TB_COLLAPSE tbody td {
    border: solid 1px #797979;
  }
  table.TB_COLLAPSE tbody th {
    padding: 0;
    border-bottom: 1px solid #797979;
  }
  table.TB_COLLAPSE {
    border: none;
  }
  .TB_COLLAPSE.inner-table tbody td {
    border: none;
  }
  .inner-table {
    display: inline-block;
    box-sizing: border-box;
    vertical-align: top;
    border-collapse: collapse;
    border-spacing: 0;
    .title {
      background-color: #e3ecec;
      border: solid 1px #797979;
      border-bottom: none;
      border-left: none;
      min-width: 180px;
    }
    .check-part {
      border-top: solid 1px #797979;
      &:first-of-type {
        border: none;
      }
    }
    td {
      padding: 0;
    }
  }
}
</style>